export default __webpack_public_path__ + "static/media/duck@2x.454a7ade.png";